import React from 'react';
import {observer} from 'mobx-react';
import {Panel, FormLayout, ActionLink, Input, Select2} from 'components';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import {t} from 'shared/core';

const ReductionsForm = observer(({uiState}) => {
  const {currentCoverage, errors} = uiState;
  if (currentCoverage.isOptionalCoverage) return null;

  return (
    <div>
      <Panel.Separator />
      <Panel.Subheader title={t('taxable_benefits.Reductions')}/>
      <FormLayout>
        {currentCoverage.coverageVolumeReductions.map((reduction, index) =>
          <div key={index}>
            <div className='table'>
              <div className='col-6 table-cell align-middle medium'>
                <FormattedMessage id='taxable_benefits.COVERAGE_REDUCTION' values={{index: index + 1}} />
              </div>
              <div className='col-6 table-cell align-middle right-align'>
                <ActionLink subdued onClick={() => uiState.removeVolumeReduction(reduction)}>
                  <FormattedMessage id='taxable_benefits.Remove' />
                </ActionLink>
              </div>
            </div>
            <FormLayout>
              <FormLayout.Group>
                <Input value={reduction.age}
                  onChange={e => reduction.merge({age: e.target.value})}
                  label='taxable_benefits.Age'
                  errorMessage={_.get(errors, `coverageVolumeReductions[${index}].age`)}
                />
                <Select2 value={reduction.reductionType}
                  onChange={e => reduction.merge({reductionType: e.target.value})}
                  label='taxable_benefits.Type'
                  errorMessage={_.get(errors, `coverageVolumeReductions[${index}].reductionType`)}>
                  <option value='amount'>{t('taxable_benefits.Amount')}</option>
                  <option value='percentage'>{t('taxable_benefits.Percent')}</option>
                </Select2>
              </FormLayout.Group>
              {reduction.isAmount &&
                <Input value={reduction.amount}
                  onChange={e => reduction.merge({amount: e.target.value})}
                  label='taxable_benefits.Amount'
                  errorMessage={_.get(errors, `coverageVolumeReductions[${index}].amount`)}
                  helpMessage='taxable_benefits.help_text.coverage_volume_reduction_amount'
                />}
              {reduction.isPercentage &&
                <Input value={reduction.percentage}
                  onChange={e => reduction.merge({percentage: e.target.value})}
                  label='taxable_benefits.Percent'
                  errorMessage={_.get(errors, `coverageVolumeReductions[${index}].percentage`)}
                  helpMessage='taxable_benefits.help_text.coverage_volume_reduction_percentage'
                />}
            </FormLayout>
          </div>)}
        <ActionLink onClick={() => uiState.addVolumeReduction()}>
          <FormattedMessage id='taxable_benefits.+ Add Coverage Reduction'/>
        </ActionLink>
      </FormLayout>
    </div>
  );
});

export default ReductionsForm;
